import React, { useState } from 'react';
import { SubmitHandler, useForm, Controller } from "react-hook-form";
import { Box, Button, VStack, Heading, Span, HStack, Text } from '@bpba/ui-components';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { PaquetesNyPSP } from '../rest/models/PaquetesNyPSP';
import { Localidad } from '../rest/models/Localidad';
import { Queries } from '../rest/Queries';
import { useMutation, useQuery } from '@apollo/client';
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { PaquetesNyPSPApiRQ } from '../rest/models/PaquetesNyPSPApiRQ';
import { postPaquetesNyPSP } from '../rest/mutations/postPaquetesNyPSP';
import { Mutations } from '../rest/Mutations';
import { Result } from './Result';
import { ResultError } from './ResultError';
import { useNavigate } from 'react-router-dom';
import { PAQUETES_NYP } from '../Constantes';
import ComboSucursales from "./ComboSucursales";

export const PaquetesNyPSPComponente: React.FC = () => {

    const { register, handleSubmit, control, formState: { errors }, reset } = useForm<PaquetesNyPSP>({
        mode: 'onChange',
        criteriaMode: 'all', reValidateMode: 'onChange',
        defaultValues: {
            sucursal: ""

        }
    });
    const REQUIRED_FIELD = "Campo requerido.";
    const numberValidator = /^\d+$/;
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>()
    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const [postPaquetesNyPSPAPI, { loading: loadingMutation }] = useMutation<Mutations>(postPaquetesNyPSP);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>();
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const navigate = useNavigate();
    const [adjuntar, setAdjuntar] = useState(false);
    const [nroSolicitud, setNroSolicitud] = useState(0);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');
    const { executeRecaptcha } = useGoogleReCaptcha();

    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);

    }
   

    const onSubmit: SubmitHandler<PaquetesNyPSP> = async (data: PaquetesNyPSP) => {

        if (data.condicionImpositiva === "6") {
            setServicioOk(true);
            setMensajeRtaServicio("no puede acceder al producto");
        } else {
            const token = executeRecaptcha && (await executeRecaptcha('PaquetesNyP'));
            let datos: PaquetesNyPSPApiRQ = {
                "googleToken": token,
                "razonSocial": data.nombreyApellido,
                "cuit": data.cuit.toString(),
                "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
                "localidad": data.provincia.split('-')[1] + "," + data.localidad + "," + data.calle + " " + data.numeroCalle + "," + data.piso,
                "email": data.email,
                "sucursal": Number.parseInt((data.sucursal === "0" ? "1000" : data.sucursal)),
                "condicionImpositiva": data.condicionImpositiva,
                "EsComerciante": data.esComerciante,
                "origenSolicitud": origenSolicitud === null ? "" : origenSolicitud
            };
            await postPaquetesNyPSPAPI({ variables: { input: datos } }).then((response: any) => {

                if (response !== null || response !== undefined) {
		    setServicioOk(true);
                    if (response.data.PaquetesNyPSPApiRQ.resultado === "ok") {                

                        setNroSolicitud(response.data?.PaquetesNyPSPApiRQ.nroSolicitud)
                        setAdjuntar(true)
                        setMensajeRtaServicio(<><Text fontSize={"20px"} margin={0} fontWeight={600}>A través de la opción “Adjuntar”, podés enviar copia digitalizada de la documentación solicitada.</Text><Text fontSize={"16px"} margin={0}>Podrás cargar los siguientes formatos : image/gif, image/jpg, image/jpeg, image/png, txt, csv, bmp, tiff, pdf, docx  (tamaño máximo 1MB).</Text></>);


                    } else if (response.data.PaquetesNyPSPApiRQ.resultado === "error") {
                        
                        if(response.data.PaquetesNyPSPApiRQ.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())){
                           
                           setMensajeRtaServicio(response.data.PaquetesNyPSPApiRQ.error);
                           
                        }else{
                           
                           setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                        }
       
                   }
                } else {

                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");

                }


            }).catch(() => {
                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            });

        }


    }
    
    const handleReset = () => {
        reset({});
        window.location.reload();
    };
    const handleRedirect = () => {
        navigate('/DocumentacionAdjunta', {
            state: {
                nroSolicitud: nroSolicitud,
                banner: PAQUETES_NYP,
                titulo: "PaquetesNyP",
                masDeUnArchivo: true
            }
        });
    };

    if (adjuntar) return (
        <VStack>
            <VStack>
                <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>
                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => {setAdjuntar(false); setServicioOk(true); setMensajeRtaServicio("En los próximos días nos contactaremos con vos.");} }
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Finalizar
                        </Button>
                    </VStack>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => handleRedirect()}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%", backgroundColor: "white",
                                borderRadius: "3px 8px 3px 8px",
                                border: "solid 2px", borderColor: "#3c3c3b",
                                color: "#3c3c3b",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Adjuntar
                        </Button>
                    </VStack>
                </VStack>
            </VStack>

        </VStack>
    );


    if (loadingMutation) return <SpinnerCajas />;

    if (servicioOk) return (
        <Result handleReset={handleReset}>
             <VStack>
                <Heading level={2} fontWeight={400} children={mensajeRtaServicio} color="primary.0" tabIndex={0} />
            </VStack>
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>

    );

    return (<>
        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    <VStack mt={"20px"}>
                        <input {...register(`nombreyApellido`, { required: REQUIRED_FIELD })} maxLength={50} name='nombreyApellido' type={"text"} placeholder='Nombre y Apellido' />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombreyApellido ? "* " + errors.nombreyApellido.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register(`cuit`, { required: REQUIRED_FIELD, minLength: { value: 11, message: "Debe tener al menos 11 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' placeholder='CUIT' type={"text"} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, maxLength: 100, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='Email' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Teléfono de contacto
                        </Span>
                        <VStack mt={"8px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Área' maxLength={4} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Número' maxLength={14} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                            </VStack>
                        </VStack>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Localidad</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                    style={{ width: "100%" }}
                                    {...register("provincia", { required: REQUIRED_FIELD })}
                                    onChange={(e: any) => BuscLoc(e.target.value)} name="provincia" placeholder='Provincia' >
                                    <option value="">Ubicación</option>
                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provincia ? "* " + errors.provincia.message : ""}</Span>
                            </VStack>
                            <VStack >
                                <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidad", { required: REQUIRED_FIELD })} name="localidad" placeholder='Localidad' >
                                    <option value="" selected >Localidad/barrio</option>
                                    {localidades &&
                                        localidades.map((item: Localidad) =>
                                            <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidad ? "* " + errors.localidad.message : ""}</Span>
                            </VStack>
                        </VStack>


                        <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <input tabIndex={0}{...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle ? "* " + errors.calle.message : ""}</Span>
                            </VStack>
                            <VStack mr={"0.5rem"}>
                                <input tabIndex={0}{...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Número' maxLength={5} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle ? "* " + errors.numeroCalle.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0}{...register("piso", { required: false, maxLength: 8 })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                            </VStack>

                        </VStack>

                    </VStack>
                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Por favor, seleccioná tu Condición Impositiva</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack>
                                <select tabIndex={0} aria-label={"Por favor seleccioná tu condición impositiva"}
                                    style={{ width: "100%" }}
                                    {...register("condicionImpositiva", { required: REQUIRED_FIELD })}
                                    name="condicionImpositiva" placeholder='condicionImpositiva' >
                                    <option value="">Seleccione datos tributarios</option>
                                    <option value="1">Relación de Dependencia</option>
                                    <option value="2">Monotributista</option>
                                    <option value="3">Responsable inscripto</option>
                                    <option value="5">Jubilado/a</option>
                                    <option value="6">No puedo demostrar ingresos</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.condicionImpositiva ? "* " + errors.condicionImpositiva.message : ""}</Span>
                            </VStack>

                        </VStack>

                    </VStack>
                    <HStack mt={"8px"} ml={"3px"} alignItems={"flex-end"}>
                        <input type='checkbox' tabIndex={0} {...register("esComerciante")} name="esComerciante" style={{ transform: "scale(1.3)", marginBottom: "2px" }} />
                        <Span mt={"13px"} ml={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>¿Sos comerciante? SI / NO</Span>
                    </HStack>

                    <Controller
                                control={control}
                                name="sucursal"
                                rules={{ required: true }}
                                render={({ field }) => {
                                    return <ComboSucursales {...field} onChangeValue={(e) => { field.onChange(e) }} titulo={"Sucursal donde quéres finalizar el tramite"} sucursalCliente={undefined} />
                                }}
                            />

                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.sucursal?.message}</Span>
                         
                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>


                </form>
            </VStack>

        </Box>

    </>
    );
}